import { render } from "./AppTagAddition.vue?vue&type=template&id=90ac8bdc&scoped=true&ts=true"
import script from "./AppTagAddition.vue?vue&type=script&lang=ts"
export * from "./AppTagAddition.vue?vue&type=script&lang=ts"

import "./AppTagAddition.vue?vue&type=style&index=0&id=90ac8bdc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ac8bdc"]])

export default __exports__